import PropTypes from 'prop-types'
import React from 'react'

export default function Indicator({ notifications, isInline }) {
  const notificationDots = notifications
    .filter(n => n.shouldShowDot)
    .map(notification => (
      <div
        key={notification.message}
        className={[
          'notifications__indicator',
          `notifications__indicator--${notification.variant}`,
        ].join(' ')}
      />
    ))

  return (
    <div className={isInline ? 'notifications__dots-inline' : 'notifications__dots'}>
      {notificationDots}
    </div>
  )
}

Indicator.propTypes = {
  notifications: PropTypes.arrayOf(PropTypes.object),
}
